<div class="gm-game gm-c4">
  <div class="gm-game-bar">
    <span class="gm-game-title">Connect Four</span>
    <div class="gm-game-actions">
      <button class="gm-btn" (click)="reset()">New</button>
    </div>
  </div>
  <div class="gm-game-body">
    <div class="c4-wrap">
      <div class="c4-status">
        @if (winner() === 0) {
          <span class="c4-chip" [class.r]="turn() === 1" [class.y]="turn() !== 1"></span>
          {{ turn() === 1 ? 'Red' : 'Yellow' }}’s turn
        } @else if (winner() > 0) {
          <span class="c4-chip" [class.r]="winner() === 1" [class.y]="winner() !== 1"></span>
          {{ winner() === 1 ? 'Red' : 'Yellow' }} wins! 🎉
        } @else {
          Draw — board full
        }
      </div>
      <div class="c4-board">
        @for (cell of cells(); track cell.i) {
          <div class="c4-cell" [class.top-empty]="cell.topEmpty" (click)="drop(cell.c)">
            @if (cell.v > 0) {
              <div class="c4-disc" [class.r]="cell.v === 1" [class.y]="cell.v === 2"></div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
